import { ReactNode } from 'react';
import { useResponsive } from '../hooks/useMediaQuery';

interface BottomSheetProps {
  children: ReactNode;
}

export function BottomSheet({ children }: BottomSheetProps) {
  const { isMobile } = useResponsive();

  if (!isMobile) {
    // On tablet/desktop, render normally in flow
    return (
      <div className="flex flex-wrap gap-3 mt-6">
        {children}
      </div>
    );
  }

  // On mobile, fixed bottom sheet
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4 shadow-lg z-50">
      <div className="flex flex-col gap-3">
        {children}
      </div>
    </div>
  );
}
